import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@core/auth.service';
import { ExpiringContractsService } from './expiring-contracts-dashboard-service';

@Component({
  selector: 'app-expiring-contracts-dashboard',
  templateUrl: './expiring-contracts-dashboard.component.html',
  styleUrls: ['./expiring-contracts-dashboard.component.scss'],
})
export class ExpiringContractsDashboardComponent implements OnInit {
  contracts: any[] = [];
  filteredContracts: any[] = [];
  filterValue: string = '';
  imageSrc: string = 'assets/img/no-data-found.png';
  paginationParams = { enabled: true, pageSize: 10, pageSizeOptions: [5, 10, 20] };
  maxTableHeight: number = 475;

  columnDefs = [
    { field: 'name', headerName: 'Name', sortable: true },
    { field: 'reportingManager', headerName: 'Reporting Manager', sortable: true },
    { field: 'vendor', headerName: 'Vendor', sortable: true },
    {
      field: 'contractExpiryDate',
      headerName: 'Contract Expiry',
      sortable: true,
      valueFormatter: (params: any) => {
        const date = new Date(params.value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
      },
    },    
    { field: 'daysLeft', headerName: 'Days Left', sortable: true },
    { field: 'action', headerName: 'Action', sortable: true },
  ];

  constructor(private http: HttpClient, private authService: AuthService,private expiringContractsService: ExpiringContractsService) {}

  ngOnInit(): void {
    this.loadContracts();
  }

  loadContracts(): void {
    const employeeId = this.authService.userProfile?.employeeId;
    if (!employeeId) {
      alert('Employee ID not found');
      this.contracts = [];
      this.filteredContracts = [];
      return;
    }
    this.expiringContractsService.getExpiringContracts(employeeId.toString()).subscribe({
      next: (response) => {
        const contracts = (response.data ?? []).map((contract: any) => ({
          name: contract.name || '',
          vendor: contract.vendor || '',
          reportingManager: contract.reportingManager || '',
          contractExpiryDate: contract.contractExpiryDate || '',
          daysLeft: contract.daysLeft ?? '',
          action: '',
        }));
        // Sort contracts by contract expiry date and days left
        this.contracts = contracts.sort((a: { contractExpiryDate: string, daysLeft: string }, b: { contractExpiryDate: string, daysLeft: string }) => {
          const aValid = a.contractExpiryDate && a.daysLeft !== '' && !isNaN(Number(a.daysLeft));
          const bValid = b.contractExpiryDate && b.daysLeft !== '' && !isNaN(Number(b.daysLeft));
          if (aValid && !bValid) return -1;
          if (!aValid && bValid) return 1;
          if (aValid && bValid) return Number(a.daysLeft) - Number(b.daysLeft);
          return 0;
        });
        this.filteredContracts = [...this.contracts];
      },
      error: (err) => {
        alert('Failed to load contracts');
        this.contracts = [];
        this.filteredContracts = [];
      }
    });
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strHours = ('0' + hours).slice(-2);
    return `${day}-${month}-${year}`;
  }

  searchContracts(event: KeyboardEvent): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredContracts = this.contracts.filter((contract) =>
      Object.values(contract).some((value: any) =>
        value.toString().toLowerCase().includes(searchTerm)
      )
    );
  }

  clearInput(): void {
    this.filterValue = '';
    this.filteredContracts = [...this.contracts];
  }

  navigateToContractorProfile(contractorId: number): void {
    alert(`Navigating to contractor profile with ID: ${contractorId}`);
  }
  notifyContract(contract: any): void {
    alert(`Notification sent for contract: ${contract.name}`);
  }
}